import { SitesService } from '../../shared/services/sites.service';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientsService } from '../../shared/services/clients.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from '../../shared/services/notifications.service';
import { ConfirmationDialogService } from '../../shared/confirmation-dialog/confirmation-dialog.service';

@Component({
    selector: 'app-sites-page',
    templateUrl: './sites-page.component.html',
    styleUrls: ['./sites-page.component.css']
})
export class SitesPageComponent implements OnInit, OnDestroy {

    public items;
    public listaEquipamentos: any[] = [];
    public listaInitEquip: any[] = [];
    public listaGraficos: any[] = [];
    public listaInitGrafico: any[] = [];
    public itemsCount;
    public clients;
    @ViewChild("outroModal", { static: false })
    private outroModal: TemplateRef<any>;
    @ViewChild("content", { static: false })
    private modal: TemplateRef<any>;
    private modalFormModel;
    private mostrarFormulario = false;

    private concessionariaFormModel = { tagStatusDisjuntor: {}, tagPotenciaAtiva: {}, tagTensao: {} };
    private geradorFormModel = { name: "", tagStatus: {}, tagPotenciaAtiva: {} };
    private chillerFormModel = { name: "", tagStatus: {} };
    private caldeiraFormModel = { name: "", tagStatus: {} };

    public filterFormModel = { page: 1, pageSize: 10, idClient: 0, name: "" };
    private equipamento = {
        TipoEquipamento: '',
        NomeEquipamento: '',
        IconeEquipamento: '',
        Variavel1_Id: '',
        un1: '',
        Variavel2_Id: '',
        un2: '',
        Variavel3_Id: '',
        un3: '',
        Site_id: '',
        var_status: '',
        nomevar1: '',
        nomevar2: '',
        nomevar3: '',
    };
    private grafico = {
        TipoGrafico: '',
        NomeGrafico: '',
        CategoriaGrafico: '',
        TagEPM: '',
    };
    public nomesTiposGrafico = {
        'LI': 'Linha',
        'BA': 'Barras'
    };
    public nomesCategoriasGrafico = {
        'HO': 'Horário',
        'DI': 'Diario'
    };
    private iconeEquipamento: string = '';

    constructor(
        private sitesService: SitesService,
        private clientsService: ClientsService,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
        private notifications: NotificationsService,
        private confirmationDialogService: ConfirmationDialogService) { }

    ngOnInit() {
        this.spinner.show();
        this.clientsService.listAll().subscribe(response => {
            this.clients = response;
            this.list();
        });
    };

    ngOnDestroy() {
        this.modalService.dismissAll();
    };

    listPage(page: number) {
        this.filterFormModel.page = page;
        this.list();
    };

    list() {
        this.spinner.show();
        this.sitesService.list(this.filterFormModel).subscribe(response => {
            this.items = response.data;
            this.itemsCount = response.count;
            this.spinner.hide();

        });
    };

    atualizarIcone(event: any) {
        const valor = event.target.value;

        const mapaIcones: { [key: string]: string } = {
            PS: 'image-ps-on',  // Painel Solar
            CH: 'image-ch-on',  // Chiller
            GR: 'image-gr-on',  // Gerador
            BC: 'image-bc-on',  // Bomba de Calor
            BD: 'image-bd-on',  // Biodigestor
            SE: 'image-se-on',  // Subestação
            PC: 'image-pc-on',  // Planta CO2
            TB: 'image-tb-on',  // Turbina
            AC: 'image-ac-on',  // Ar Condicionado
            CC: 'image-cc-on',  // Concessionaria
            MN: 'image-mn-on',  // Manutencao
            BM: 'image-bm-on',  // BioMassa
            PR: 'image-pr-on',  // Processo
            OP: 'image-op-on',  // Operacional
            BA: 'image-ba-on',  // Baterias
            TT: 'image-tt-on',  //Totalizadores
            EM: 'image-em-on',  //Estação meteorológica
            SM: 'image-sm-on',  //Sistema Elétrico
            CO: 'image-co-on',  //Cogeracao
            EC: 'image-ec-on'   //Emissoes de CO2

        };

        this.iconeEquipamento = mapaIcones[valor] || '';

    };

    clearFilter() {
        this.filterFormModel.idClient = 0;
        this.filterFormModel.name = "";
        this.list();
    };

    create() {
        this.modalFormModel = {
            client: this.clients[0],
            active: true,
            tagPotenciaAtivaDespacho: {},
            tagTensaoBarra: {},
            concessionarias: []
        };
        this.modalService.open(this.modal, { size: 'xl' as 'lg', backdrop: 'static', keyboard: false });
    };
    salvarEquipamento() {
        console.log(this.equipamento);
        // lógica de salvar aqui
        this.modalService.dismissAll();

    }

    createGrupoGenerico() {
        this.modalFormModel = {
            client: this.clients[0],
            active: true,
            tagPotenciaAtivaDespacho: {},
            tagTensaoBarra: {},
            concessionarias: []
        };
        //this.modalService.open(this.outroModal);
        //this.modalService.open(this.outroModal, { size: 'lg', backdrop: 'static' });
        // this.modalService.open(this.modal, { size: 'lg', backdrop: 'static', keyboard: false });
    };
    grupoGenericosalvar() {
        // lógica de salvar
        this.mostrarFormulario = false; // fecha depois de salvar
    }

    update(post) {
        this.spinner.show();
        this.sitesService.get(post.id).subscribe(response => {

            for (var i in response.concessionarias) {
                var c = response.concessionarias[i];
                if (!c.tagStatusDisjuntor) c.tagStatusDisjuntor = {};
                if (!c.tagTensao) c.tagTensao = {};
                if (!c.tagPotenciaAtiva) c.tagPotenciaAtiva = {};
            }

            if (response.grupoGeradores && response.grupoGeradores.length > 0) {
                for (var i in response.grupoGeradores[0].geradores) {
                    var g = response.grupoGeradores[0].geradores[i];
                    if (!g.tagPotenciaAtiva) g.tagPotenciaAtiva = {};
                }
            }

            if (response.grupoChillers && response.grupoChillers.length > 0) {
                if (!response.grupoChillers[0].tagTemperaturaEnvioAguaGelada) response.grupoChillers[0].tagTemperaturaEnvioAguaGelada = {};
                if (!response.grupoChillers[0].tagTemperaturaRetornoAguaGelada) response.grupoChillers[0].tagTemperaturaRetornoAguaGelada = {};
                if (!response.grupoChillers[0].tagGeracaoAguaGelada) response.grupoChillers[0].tagGeracaoAguaGelada = {};
            }

            if (response.grupoCaldeiras && response.grupoCaldeiras.length > 0) {
                if (!response.grupoCaldeiras[0].tagGeracaoVapor) response.grupoCaldeiras[0].tagGeracaoVapor = {};
            }

            this.modalFormModel = response;
            if (!this.modalFormModel.tagPotenciaAtivaDespacho) this.modalFormModel.tagPotenciaAtivaDespacho = {};
            if (!this.modalFormModel.tagTensaoBarra) this.modalFormModel.tagTensaoBarra = {};

            this.modalFormModel.grupoGeradores = response.grupoGeradores[0];
            this.modalFormModel.grupoChillers = response.grupoChillers[0];
            this.modalFormModel.grupoCaldeiras = response.grupoCaldeiras[0];
            this.modalFormModel.client = this.clients.filter((x: any) => x.id === this.modalFormModel.client.id)[0];
            this.modalService.open(this.modal, { size: 'xl' as 'lg', backdrop: 'static', keyboard: false });
            this.spinner.hide();


            //CARREGAMENTO LISTA SITEGENERICOS
            this.listaEquipamentos = response.siteGenericos.map((item: any) => {
                return {
                    TipoEquipamento: item.tipoEquipamento,
                    NomeEquipamento: item.nomeEquipamento,
                    IconeEquipamento: item.iconeEquipamento,
                    Variavel1_Id: item.variavel1_Id,
                    un1: item.un1,
                    Variavel2_Id: item.variavel2_Id,
                    un2: item.un2,
                    Variavel3_Id: item.variavel3_Id,
                    un3: item.un3,
                    Site_id: item.site_id,
                    var_status: item.var_status,
                    nomevar1: item.nomevar1,
                    nomevar2: item.nomevar2,
                    nomevar3: item.nomevar3,
                };
            });
            this.listaInitEquip = response.siteGenericos.map((item: any) => {
                return {
                    TipoEquipamento: item.tipoEquipamento,
                    NomeEquipamento: item.nomeEquipamento,
                    IconeEquipamento: item.iconeEquipamento,
                    Variavel1_Id: item.variavel1_Id,
                    un1: item.un1,
                    Variavel2_Id: item.variavel2_Id,
                    un2: item.un2,
                    Variavel3_Id: item.variavel3_Id,
                    un3: item.un3,
                    Site_id: item.site_id,
                    var_status: item.var_status,
                    nomevar1: item.nomevar1,
                    nomevar2: item.nomevar2,
                    nomevar3: item.nomevar3,
                };
            });

            //CARREGAMENTO LISTA Graficos
            this.listaInitGrafico = response.siteGraficos.map((item: any) => {
                return {
                    NomeGrafico: item.nomeGrafico,
                    TipoGrafico: item.tipoGrafico,
                    CategoriaGrafico: item.categoriaGrafico,
                    TagEPM: item.tagEPM,
                };
            });
            //CARREGAMENTO LISTA Graficos
            this.listaGraficos = response.siteGraficos.map((item: any) => {
                return {
                    NomeGrafico: item.nomeGrafico,
                    TipoGrafico: item.tipoGrafico,
                    CategoriaGrafico: item.categoriaGrafico,
                    TagEPM: item.tagEPM,
                };
            });
        });
    };

    submitModalFormModel(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        if (this.modalFormModel.id && !form.dirty && this.listaInitEquip.length == this.listaEquipamentos.length && this.listaInitGrafico.length == this.listaGraficos.length) {
            console.log(form);
            this.modalService.dismissAll();
            return;
        }

        let requestModel = Object.assign({}, this.modalFormModel);
        requestModel.idClient = this.modalFormModel.client.id;

        //linha para gravação da lista Equipamentos
        requestModel.grupoGenericos = this.listaEquipamentos;
        requestModel.grupoGraficos = this.listaGraficos;
        this.mostrarFormulario = false;

        let outerThis = this;
        let callback = function (response) {
            outerThis.spinner.hide();
            if (!response.success) {
                outerThis.notifications.errors(response.payload.messages);
                return;
            }
            outerThis.notifications.success(!outerThis.modalFormModel.id ? 'Cadastro de novo site realizado com sucesso.' : 'Dados do site atualizados com sucesso.');
            outerThis.modalService.dismissAll();
            outerThis.list();
        };

        if (requestModel.id) {
            // update
            this.spinner.show();
            this.sitesService.update(requestModel).subscribe(callback);

        } else {
            // create
            this.spinner.show();
            this.sitesService.create(requestModel).subscribe(callback);
        }
    };

    closeModalFormModel(form) {
        if (!form.dirty) {
            this.modalService.dismissAll();
            return;
        }

        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.modalService.dismissAll();
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja cancelar as alterações realizadas ?', "Sim", "Não").then(confirmedCallback);
    };

    delete(post) {
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.spinner.show();
            outherThis.sitesService.delete(post).subscribe(response => {
                outherThis.spinner.hide();
                if (!response.success) {
                    outherThis.notifications.errors(response.payload.messages);
                    return;
                }
                outherThis.notifications.success('Cadastro de site removido com sucesso.');
                outherThis.list();
            });
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja remover este site ?').then(confirmedCallback);
    };

    addConcessionaria(form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());

        if (!this.modalFormModel.concessionarias) {
            this.modalFormModel.concessionarias = [];
        }

        this.modalFormModel.concessionarias.push(Object.assign({ id: new Date().getTime() }, this.concessionariaFormModel));
        this.concessionariaFormModel = { tagStatusDisjuntor: {}, tagPotenciaAtiva: {}, tagTensao: {} };
    };

    removeConcessionaria(c, form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());

        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) return;
            outherThis.modalFormModel.concessionarias.splice(outherThis.modalFormModel.concessionarias.indexOf(c), 1);
        };
        this.confirmationDialogService.confirm('Tem certeza de que deseja remover esta concessionária ?').then(confirmedCallback);
    };

    addGerador(form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        if (!this.modalFormModel.grupoGeradores) {
            this.modalFormModel.grupoGeradores = {
                geradores: []
            };
        }

        this.modalFormModel.grupoGeradores.geradores.push(Object.assign({ id: new Date().getTime(), name: "Gerador " + this.modalFormModel.grupoGeradores.geradores.length + 1 }, this.geradorFormModel));
        this.geradorFormModel = { name: "", tagStatus: {}, tagPotenciaAtiva: {} };
    };

    removeGerador(c, form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) return;

            outherThis.modalFormModel.grupoGeradores.geradores.splice(outherThis.modalFormModel.grupoGeradores.geradores.indexOf(c), 1);
            if (outherThis.modalFormModel.grupoGeradores.geradores.length == 0) {
                delete outherThis.modalFormModel.grupoGeradores;
            }
        };
        this.confirmationDialogService.confirm('Tem certeza de que deseja remover este gerador ?').then(confirmedCallback);
    };

    addChiller(form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        if (!this.modalFormModel.grupoChillers) {
            this.modalFormModel.grupoChillers = {
                tagTemperaturaEnvioAguaGelada: {},
                tagTemperaturaRetornoAguaGelada: {},
                tagGeracaoAguaGelada: {},
                chillers: []
            };
        }

        this.modalFormModel.grupoChillers.chillers.push(Object.assign({ id: new Date().getTime(), name: "Chiller " + this.modalFormModel.grupoChillers.chillers.length + 1 }, this.chillerFormModel));
        this.chillerFormModel = { name: "", tagStatus: {} };
    };

    removeChiller(c, form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) return;

            outherThis.modalFormModel.grupoChillers.chillers.splice(outherThis.modalFormModel.grupoChillers.chillers.indexOf(c), 1);
            if (outherThis.modalFormModel.grupoChillers.chillers.length == 0) {
                delete outherThis.modalFormModel.grupoChillers;
            }
        };
        this.confirmationDialogService.confirm('Tem certeza de que deseja remover este chiller ?').then(confirmedCallback);
    };

    addCaldeira(form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        if (!this.modalFormModel.grupoCaldeiras) {
            this.modalFormModel.grupoCaldeiras = {
                tagGeracaoVapor: {},
                caldeiras: []
            };
        }
        this.modalFormModel.grupoCaldeiras.caldeiras.push(Object.assign({ id: new Date().getTime(), name: "Caldeira " + this.modalFormModel.grupoCaldeiras.caldeiras.length + 1 }, this.caldeiraFormModel));
        this.caldeiraFormModel = { name: "", tagStatus: {} };
    };

    removeCaldeira(c, form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) return;

            outherThis.modalFormModel.grupoCaldeiras.caldeiras.splice(outherThis.modalFormModel.grupoCaldeiras.caldeiras.indexOf(c), 1);
            if (outherThis.modalFormModel.grupoCaldeiras.caldeiras.length == 0) {
                delete outherThis.modalFormModel.grupoCaldeiras;
            }
        };
        this.confirmationDialogService.confirm('Tem certeza de que deseja remover esta caldeira ?').then(confirmedCallback);
    };

    salvarGrupoSiteGenerico() {
        // Validação básica
        if (!this.equipamento.TipoEquipamento || !this.equipamento.NomeEquipamento || !this.equipamento.Variavel1_Id || !this.equipamento.un1) {
            alert('Preencha todos os campos obrigatórios (*)');
            return;
        }
        const novoEquipamento = {
            TipoEquipamento: this.equipamento.TipoEquipamento,
            NomeEquipamento: this.equipamento.NomeEquipamento,
            IconeEquipamento: this.iconeEquipamento,
            Variavel1_Id: this.equipamento.Variavel1_Id,
            un1: this.equipamento.un1,
            Variavel2_Id: this.equipamento.Variavel2_Id,
            un2: this.equipamento.un2,
            Variavel3_Id: this.equipamento.Variavel3_Id,
            un3: this.equipamento.un3,
            Site_id: this.modalFormModel.id.toString(),
            var_status: this.equipamento.var_status,
            nomevar1: this.equipamento.nomevar1,
            nomevar2: this.equipamento.nomevar2,
            nomevar3: this.equipamento.nomevar3
        };
        this.listaEquipamentos.push(novoEquipamento);
        this.equipamento = { TipoEquipamento: '', NomeEquipamento: '', IconeEquipamento: '', Variavel1_Id: '', un1: '', Variavel2_Id: '', un2: '', Variavel3_Id: '', un3: '', Site_id: '', var_status: '', nomevar1: '', nomevar2: '', nomevar3: '' };
        this.iconeEquipamento = '';
        // Monta o objeto igual ao C# espera
        // const novoSiteGenerico = {
        //     site_id: { id: this.siteId }, // Aqui você passa o ID do site relacionado
        //     tipoEquipamento: this.equipamento.tipo,
        //     nomeEquipamento: this.equipamento.nome,
        //     iconeEquipamento: this.iconeEquipamento || '', // caso queira mandar o ícone
        //     variavel1_Id: this.equipamento.var1,
        //     un1: this.equipamento.un1,
        //     variavel2_Id: this.equipamento.var2 || null,
        //     un2: this.equipamento.un2 || null,
        //     variavel3_Id: this.equipamento.var3 || null,
        //     un3: this.equipamento.un3 || null
        // };

        // this.http.post('/api/sitegenericos', novoSiteGenerico).subscribe({
        //     next: () => {
        //     alert('Site genérico salvo com sucesso!');
        //     this.mostrarFormulario = false;
        //     this.equipamento = {};
        //     },
        //     error: (err) => {
        //     console.error(err);
        //     alert('Erro ao salvar site genérico.');
        //     }
        // });
    }
    salvarGrupoSiteGrafico() {
        // Validação básica
        if (!this.grafico.TipoGrafico || !this.grafico.NomeGrafico || !this.grafico.CategoriaGrafico || !this.grafico.TagEPM) {
            alert('Preencha todos os campos obrigatórios (*)');
            return;
        }
        const novoGrafico = {
            TipoGrafico: this.grafico.TipoGrafico,
            NomeGrafico: this.grafico.NomeGrafico,
            CategoriaGrafico: this.grafico.CategoriaGrafico,
            TagEPM: this.grafico.TagEPM,

        };
        this.listaGraficos.push(novoGrafico);
        this.grafico = { TipoGrafico: '', NomeGrafico: '', CategoriaGrafico: '', TagEPM: '' };


    }
}


